import { locations } from './forms/formFields';

export const templateColumnConfigs = [
  {
    header: 'Location Name*',
    key: 'locationName',
    width: 35,
    required: true,
    example: 'Head Office',
    type: 'Text',
  },
  {
    header: 'Type*',
    key: 'locationType',
    width: 50,
    required: true,
    options: [
      'Call Center',
      'Contract Manufacture',
      'Data Center',
      'External Location',
      'Finished Goods Warehouse',
      'Manufacturing',
      'Office',
      'Test Facility',
      'Third Party Logistics',
      'Distribution Center',
      'Supplier',
      'Other',
    ],
    hashMap: locations,
    example: 'Data Center',
  },
  {
    header: 'Country*',
    key: 'country',
    width: 35,
    required: true,
    example: 'United States',
    type: 'Text',
  },
  {
    header: 'Rebuild Time*',
    key: 'rebuildTime',
    width: 35,
    required: true,
    example: '12',
    type: 'Number (months)',
  },
  {
    header: 'Street (Optional)',
    key: 'street',
    width: 35,
    example: '123 Main St',
    type: 'Text',
  },
  {
    header: 'City (Optional)',
    key: 'city',
    width: 35,
    example: 'San Francisco',
    type: 'Text',
  },
  {
    header: 'State (Optional)',
    key: 'state',
    width: 35,
    example: 'CA',
    type: 'Text',
  },
  {
    header: 'Zip Code (Optional)',
    key: 'zipCode',
    width: 35,
    example: '94105',
    type: 'Text',
  },

  {
    header: 'Rebuild Cost (Optional)',
    key: 'rebuildCost',
    width: 35,
    example: '100000',
    type: 'Number (USD)',
  },
];
